import { render, staticRenderFns } from "./attributionlist.vue?vue&type=template&id=71fb91a6&scoped=true"
import script from "./attributionlist.vue?vue&type=script&lang=js"
export * from "./attributionlist.vue?vue&type=script&lang=js"
import style0 from "./attributionlist.vue?vue&type=style&index=0&id=71fb91a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb91a6",
  null
  
)

export default component.exports